import type { SnapdomPlugin } from '@zumer/snapdom';

import { schaalMaat } from './beeld';
import { maskeer } from './maskeren';

/**
 * P3: a picture of what the customer sees right now -- the viewport, not the
 * whole page -- with text masked unless `toon`. Masking runs on snapdom's
 * clone (afterClone), never on the live page. Elements with
 * data-capture="exclude" (the report button, the panel) are left out by
 * snapdom itself. null = the capture failed; the melding then goes without it.
 * ponytail: captures <body> and crops; switch to capturing only #main if this
 * gets slow on long pages.
 */
export async function legSchermVast(toon: boolean): Promise<HTMLCanvasElement | null> {
  try {
    // afterClone gets the detached clone (CaptureContext.clone in snapdom's types).
    const masker: SnapdomPlugin = {
      name: 'meld-masker',
      afterClone(ctx) {
        if (ctx.clone) maskeer(ctx.clone, { toon });
      },
    };
    // Loaded on first use: snapdom stays out of the main bundle until someone reports.
    const { snapdom } = await import('@zumer/snapdom');
    const heel = await snapdom.toCanvas(document.body, { dpr: 1, plugins: [masker] });
    const body = document.body.getBoundingClientRect();
    const { w, h } = schaalMaat(window.innerWidth, window.innerHeight);
    const uit = document.createElement('canvas');
    uit.width = w;
    uit.height = h;
    const ctx = uit.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(heel, -body.left, -body.top, window.innerWidth, window.innerHeight, 0, 0, w, h);
    return uit;
  } catch {
    return null;
  }
}
